import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MDBBtn } from 'mdbreact';
import 'antd/dist/antd.css';

import { Select, Drawer, Tabs, Upload } from 'antd';
import { GetLicenciasFacturacionDesgloseTareasEnAPI, GetListaHTMLEnAPI, GetListaPDFEnAPI, GetCSVEnAPI, GetLicenciasFacturacionDesgloseTareaHtmlEnAPI } from "../../action/actionCreatorsRequests";

import { MSGERROR, MSGOK, traducirPagina, descargarPdfPasandoBase64, descargarDocPasandoBase64Generico, convertirCodigoAMeses } from "../../librerias/funciones"
import FichaImpresionGenerico from '../../components/FichaImpresionGenerico'

import FichaInfoConsulta from '../../components/NextAssist/FichaInfoConsulta'
import {
    SearchOutlined,
    CloseOutlined,
    UserOutlined,
    ShopOutlined,
    PrinterOutlined,
    EyeOutlined,
    MobileOutlined,
    DesktopOutlined,
    CustomerServiceOutlined
} from '@ant-design/icons';
const { Dragger } = Upload;
const { Option } = Select;
const { TabPane } = Tabs;

const FichaHistoricoTaller = ({ props, configApp, }) => {
    const [abrirFichaInfoConsulta, setAbrirFichaInfoConsulta] = React.useState(false);
    const [htmlTarea, setHtmlTarea] = React.useState("");

    const [DOC_HTML, setDOC_HTML] = React.useState("");
    const [hayEmpresa, setHayEmpresa] = React.useState(false);
    const [licencias, setLicencias] = React.useState([]);
    const [licenciasAux, setLicenciasAux] = React.useState([]);


    const [abrirImpresion, setAbrirImpresion] = React.useState(false);
    const [textoBuscador, setTextoBuscador] = React.useState("");
    const [estadoCliente, setEstadoCliente] = React.useState(false);
    const [estadoMostrador, setEstadoMostrador] = React.useState(false);
    const [filtroPorDecto, setFiltroPorDecto] = React.useState(0);
    const [totales, setTotales] = React.useState({
        TOTAL_CLIENTES: 0,
        TOTAL_MOSTRADORES: 0,
        TOTAL_LICENCIAS: 0
    });





    const buscarRegistros = (MES, ANYO, ID_TALLER) => {
        GetLicenciasFacturacionDesgloseTareasEnAPI(MES, ANYO, ID_TALLER).then((licencia) => {
            if (licencia !== undefined) {
                if (licencia.REGISTROS !== undefined && licencia.REGISTROS !== null && licencia.REGISTROS.length > 0) {
                    setLicencias(licencia.REGISTROS)
                    setLicenciasAux(licencia.REGISTROS)
                    let totalLicencias = 0;
                    let totalLicenciasTalleres = 0;
                    let totalLicenciasMostradores = 0;

                    licencia.REGISTROS.map((registro) => {
                        totalLicencias += registro.LICENCIAS_SERTEC
                        if (registro.TIPO === "C") {
                            totalLicenciasTalleres += registro.LICENCIAS_SERTEC
                        }

                        if (registro.TIPO === "M") {
                            totalLicenciasMostradores += registro.LICENCIAS_SERTEC
                        }
                    })

                    setTotales({
                        TOTAL_CLIENTES: totalLicenciasTalleres,
                        TOTAL_MOSTRADORES: totalLicenciasMostradores,
                        TOTAL_LICENCIAS: totalLicencias
                    })
                } else {
                    setLicencias(null)
                    setLicenciasAux(null)

                }
            }
        })

    }




    const documento_consulta = (ID_TAREA, IDIOMA) => {
        setHtmlTarea("")
        GetLicenciasFacturacionDesgloseTareaHtmlEnAPI(ID_TAREA, IDIOMA).then((REGISTRO) => {
            if (REGISTRO !== undefined && REGISTRO !== null) {
                setHtmlTarea(REGISTRO.HTML);
            } else {
                setHtmlTarea(null);
            }
        })
    }


    const filtrarEnTabla = (palabra, registros) => {
        let resultado = []
        if (palabra !== "") {
            if (registros !== null) {
                let resultadoFiltro = registros.filter((item) => {
                    return item.PLATAFORMA.toUpperCase() === palabra.toUpperCase() ||
                        item.PLATAFORMA.toUpperCase().includes(palabra.toUpperCase()) ||
                        item.FECHA_ALTA.toString().toUpperCase().includes(palabra.toUpperCase()) ||
                        item.FECHA_CIERRE.toString().toUpperCase().includes(palabra.toUpperCase()) ||
                        item.DURACION.toString().toUpperCase().includes(palabra.toUpperCase())


                })

                if (resultadoFiltro.length > 0) {
                    //setProveedores(resultadoFiltro);
                    resultado = resultadoFiltro;
                } else {
                    //setProveedores(null);
                    //resultado = registros;
                    resultado = null;
                }
            }
        } else {
            resultado = licenciasAux;
            //setProveedores(proveedoresAUX);
        }

        return resultado;

    }


    const buscarDocumento = () => {
        const TITULO = `${traducirPagina("Facturacion").toUpperCase()} ${traducirPagina(convertirCodigoAMeses(props.MES.toString())).toUpperCase()} ${props.ANYO}`;
        const SUBTITULO = `${props.title} ${props.REGISTRO_SELECCIONADO.TALLER}`

        const REGISTROS = licencias.map(registro => {
            return { PLATAFORMA: registro.PLATAFORMA, TECNICO: registro.TECNICO, ALTA: registro.FECHA_ALTA, CIERRE: registro.FECHA_CIERRE, DURACION: registro.DURACION };
        });

        GetListaHTMLEnAPI(REGISTROS, TITULO, SUBTITULO).then((doc) => {
            if (doc !== undefined) {
                if (doc !== null || doc !== "") {
                    setDOC_HTML(doc.HTML)
                } else {
                    setDOC_HTML(null)
                }
            }
        })
    }

    const buscarDocumentoPDF = () => {
        const TITULO = `${traducirPagina("Facturacion").toUpperCase()} ${traducirPagina(convertirCodigoAMeses(props.MES.toString())).toUpperCase()} ${props.ANYO}`;
        const SUBTITULO = `${props.title} ${props.REGISTRO_SELECCIONADO.TALLER}`
        const REGISTROS = licencias.map(registro => {
            return { PLATAFORMA: registro.PLATAFORMA, TECNICO: registro.TECNICO, ALTA: registro.FECHA_ALTA, CIERRE: registro.FECHA_CIERRE, DURACION: registro.DURACION };
        });
        GetListaPDFEnAPI(REGISTROS, TITULO, SUBTITULO).then((doc) => {
            if (doc !== undefined) {
                if (doc.PDF !== "" && doc.PDF !== null) {
                    descargarPdfPasandoBase64(doc.PDF)
                }
            }
        })
    }

    const buscarDocumentoCSV = () => {
        const REGISTROS = licencias.map(registro => {
            return { PLATAFORMA: registro.PLATAFORMA, TECNICO: registro.TECNICO, ALTA: registro.FECHA_ALTA, CIERRE: registro.FECHA_CIERRE, DURACION: registro.DURACION };
        });
        GetCSVEnAPI(REGISTROS).then((doc) => {
            if (doc !== undefined) {
                if (doc.CSV !== "" && doc.CSV !== null) {
                    descargarDocPasandoBase64Generico(doc.CSV, "csv")

                }
            }
        })
    }



    const filtrarDatosLocales = (licencias, esMostrador, textoBuscador) => {
        let filtroLicencias = [...licencias];

        if (esMostrador > 0) {
            filtroLicencias = filtroLicencias.filter((item) => (esMostrador === 2) ? item.TIPO === "C" : item.TIPO === "M")
        }
        if (textoBuscador !== "") {
            filtroLicencias = filtrarEnTabla(textoBuscador, filtroLicencias)
        }

        let verificarLicencia = filtroLicencias === undefined || filtroLicencias === null ? null : filtroLicencias.length === 0 ? null : filtroLicencias
        setLicencias(verificarLicencia)
    }

    if (!hayEmpresa && props.ABRIR_FICHA) {
        setHayEmpresa(true);


        buscarRegistros(props.MES, props.ANYO, props.REGISTRO_SELECCIONADO.ID_TALLER);




    } else {
        if (!props.ABRIR_FICHA && hayEmpresa) {
            setHayEmpresa(false);

        }
    }



    return (
        <div>
            <Drawer
                width={"60%"}
                onClose={() => { props.CERRAR_FICHA(false) }}
                visible={props.ABRIR_FICHA}
                closable={false}

                placement={"right"}
                bodyStyle={{ padding: '0px' }}
                style={{ color: '#fff' }}>

                       
                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => { props.CERRAR_FICHA(false) }}></CloseOutlined>
                        <div>  {`${props.title} ${props.REGISTRO_SELECCIONADO.TALLER}`}</div>
                    </div>
                </div>


               

                <div style={{ margin: '10px' }}>
                    <div className="flex-container mdb-skin" style={{ backgroundColor: '#dcdcdc', padding: '10px', marginBottom: '10px' }}>

                        <div style={{ flexGrow: '6', textAlign: 'left' }}>
                            <div className="grid-container" style={{ backgroundColor: '#eee' }}>
                                <div className="grid-item">
                                    <input id="buscadorClienteTaller" className="form-control" type="text" aria-label="Search" placeholder={traducirPagina("Buscar_en_tabla")} style={{ backgroundColor: "transparent", width: '310px', border: '0px', height: '100%', color: '#000' }} name="txtInputCliente" autoComplete="off" onChange={(e) => {
                                        filtrarDatosLocales(licenciasAux, estadoCliente ? 2 : estadoMostrador ? 1 : 0, e.target.value)


                                        setTextoBuscador(e.target.value)
                                    }} value={textoBuscador} />
                                </div>

                                <div className="grid-item" >
                                    <button id="closeBuscadorClienteTaller" style={{ border: '0', padding: '6px 5px 5px 7px', margin: '0', boxShadown: 'none', visibility: textoBuscador.trim() === "" ? 'hidden' : 'visible' }} className="btn-matriculav2" onClick={(e) => {
                                        setTextoBuscador("");
                                        filtrarDatosLocales(licenciasAux, estadoCliente ? 2 : estadoMostrador ? 1 : 0, "")
                                    }}>  <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </button>
                                </div>

                                <div className="grid-item barraLateral" ></div>

                                <div className="grid-item">
                                    <button onClick={e => { }} style={{ border: '0', padding: '6px 1px 5px 7px', margin: '0', boxShadown: 'none' }} className="btn-matricula">  <SearchOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </button>
                                </div>
                            </div>
                        </div>



                        <div style={{ marginTop: '10px' }}>

                            <PrinterOutlined style={{ fontSize: '20px', verticalAlign: 'bottom', marginLeft: '10px', color: '#1890ff', cursor: 'pointer' }} onClick={(e) => { setAbrirImpresion(true); buscarDocumento(); }} />
                        </div>

                    </div>


                    {licencias === undefined || licencias === null ?
                        <div style={{ textAlign: 'center' }}>
                            <h4>{traducirPagina("Sin_registros")}</h4>
                        </div>
                        :
                        licencias.length > 0 ?
                            <div style={{ height: (configApp.height - 160).toString() + "px", overflowX: 'hidden', overflowY: 'auto' }}>
                                <table style={{ border: '1px solid #d9d9d9', width: '100%' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#e0e0e0', color: '#000' }}>

                                            <th style={{ width: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Plataforma").toUpperCase()} </th>
                                            <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Tecnico").toUpperCase()} </th>
                                            <th style={{ width: '200px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Alta").toUpperCase()}</th>
                                            <th style={{ width: '200px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Cierre").toUpperCase()} </th>
                                            <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Duracion").toUpperCase()} </th>
                                            <th style={{ width: '45px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{ } </th>

                                        </tr>
                                    </thead>
                                    <tbody >
                                        {licencias.map((licencia, i) =>

                                            <tr key={i} style={{ backgroundColor: '#fff', color: '#000' }}>

                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}><div style={{ display: 'flex', justifyContent: 'center' }}>  {licencia.PLATAFORMA === "1" ? <MobileOutlined style={{ fontSize: '22px', color: '#007bff' }}></MobileOutlined> : licencia.PLATAFORMA === "3" ? <DesktopOutlined style={{ fontSize: '22px', color: '#0657ae' }}></DesktopOutlined> : licencia.PLATAFORMA === "2" ? <CustomerServiceOutlined style={{ fontSize: '22px', color: '#000' }}></CustomerServiceOutlined> : null}</div></td>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{licencia.TECNICO}</td>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{licencia.FECHA_ALTA}</td>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{licencia.FECHA_CIERRE}</td>

                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.DURACION}</td>

                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>
                                                    <div className="flex-container-Grow-Simple">
                                                        <div style={{ margin: '0px 2px' }} >
                                                            <button title={"Más ìnformación"} onClick={() => {
                                                                /*
                                                                setRegistroSeleccionado(licencia)
                                                                setAbrirFichaEstadistica(true)
                                                                */

                                                                documento_consulta(licencia.ID_TAREA, "ES")
                                                                setAbrirFichaInfoConsulta(true)

                                                            }}
                                                                className="btn-matricula  estiloBotonRemove paddindDeTres">
                                                                <EyeOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>

                                        )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                    }
                </div>
            </Drawer>

            {abrirImpresion ?
                <FichaImpresionGenerico

                    title={traducirPagina("Impresion_doc").toUpperCase()}
                    ABRIR_FICHA={abrirImpresion}
                    CERRAR_FICHA={setAbrirImpresion}

                    DOCUMENTO={DOC_HTML}
                    MODIFICAR_DOCUMENTO={setDOC_HTML}
                    DESCARGAR_DOCUMENTO={buscarDocumentoPDF}
                    DESCARGAR_CSV={buscarDocumentoCSV}
                    VER_CSV={true}

                ></FichaImpresionGenerico>
                :
                null
            }



            {
                abrirFichaInfoConsulta ?
                    <FichaInfoConsulta
                        title={traducirPagina("Consulta").toUpperCase()}
                        ABRIR_FICHA={abrirFichaInfoConsulta}
                        CERRAR_FICHA={setAbrirFichaInfoConsulta}
                        HTML_TAREA={htmlTarea}
                    >
                    </FichaInfoConsulta>
                    :
                    null
            }
        </div>

    )

}
FichaHistoricoTaller.propTypes = {
    title: PropTypes.string,
    ABRIR_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    MES: PropTypes.number,
    ANYO: PropTypes.number,
    ID_SOCIO: PropTypes.number,
    REGISTRO_SELECCIONADO: PropTypes.object
};

const mapStateToProps = (state, props) => {
    return {
        configApp: state.configApp,
        props: props,
        openDrawerEmpresa: state.estadoDrawer.openDrawerEmpresa,

    };
}

export default connect(mapStateToProps)(FichaHistoricoTaller);